import { ReactElement } from 'react';
import { IsLoginChecker } from '../../../common/checkers/IsLoginChecker';
import { t } from '../../../common/getTranslations';
import { Layout } from '../../../design-system/layout/Layout';
import { getIsLegacyVersionUpdateError, showLegacyVersionUpdateDialog } from '../../../dialog/legacyVersionUpdateDialog';
import { CreditRefundAgreementContainer } from '../../../domain/credit-refund/agreement/container/CreditRefundAgreementContainer';
import { getSerializedPagewebError } from '../../../errors/getSerializedPagewebError.function';
import { CommonMobileHeaderType } from '../../../header/constants';
import { ReactQueryFetcher } from '../../../reactQuery/ReactQueryFetcher';
import { useRefundableAmountQuery } from '../../../wrapper/billingWrapper';
function CreditRefundableAmount() {
  return <IsLoginChecker>
      <ReactQueryFetcher reactQuery={useRefundableAmountQuery} options={{
      refetchOnMount: true
    }} onError={error => {
      const serializedError = getSerializedPagewebError(error);
      if (getIsLegacyVersionUpdateError(serializedError?.resultCode)) {
        showLegacyVersionUpdateDialog();
        return;
      }
    }}>
        {refundableAmount => <CreditRefundAgreementContainer refundableAmountData={refundableAmount} />}
      </ReactQueryFetcher>
    </IsLoginChecker>;
}
CreditRefundableAmount.getLayout = function getLayout(page: ReactElement) {
  return <Layout title={t('more_customer_cash_refund')} mobileLayoutConfig={{
    shouldShowHeader: true,
    headerType: CommonMobileHeaderType.FourDepth,
    headerCustomTiaraObject: {
      click: {
        layer1: '고객센터'
      }
    }
  }} pcLayoutConfig={{
    shouldShowHeader: true,
    shouldShowFooter: false
  }}>
      {page}
    </Layout>;
};
export default CreditRefundableAmount;